import { trackPaymentSubmitFail } from '../../analytics/payment';
import { PAYMENT_FORM_ID, SEPA_INPUT_NAME } from '../../payment/constants';
import type { PaymentActionFailure, SepaField } from '../../payment/types';

/** Tracks the failed submit, shows the session-expired message if any and focuses the first invalid SEPA input. */
export function showPaymentErrors(failure: PaymentActionFailure, setError: (message: string) => void): void {
  trackPaymentSubmitFail();

  if (failure.generalError) {
    setError(failure.generalError);
  }

  const firstField = Object.keys(failure.fieldErrors)[0] as SepaField | undefined;
  const form = document.getElementById(PAYMENT_FORM_ID);

  if (!firstField || !(form instanceof HTMLFormElement)) {
    return;
  }

  const input = form.elements.namedItem(SEPA_INPUT_NAME[firstField]);

  if (input instanceof HTMLElement) {
    input.focus();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
